export default "__VITE_ASSET__00366feb__"